<template>
  <section id="solutions" class="solutions">
    <div class="container">
      <header class="section-head">
        <h2 class="section-title">解决方案</h2>
        <p class="section-lead">
          以物联网技术为核心，面向图书馆提供先进、稳定、高效的智能化解决方案
        </p>
      </header>
      <div class="solutions-grid">
        <article
          v-for="(item, idx) in items"
          :key="item.id != null ? item.id : idx"
          class="solution-card"
        >
          <router-link
            :to="{ name: 'solution-detail', params: { id: String(item.id) } }"
            class="solution-link"
          >
            <div class="solution-media" :class="{ 'solution-media--ready': imageReady[item.id] }">
              <img
                v-if="item.image"
                :src="item.image"
                :alt="item.title"
                class="solution-cover"
                :loading="idx < 8 ? 'eager' : 'lazy'"
                decoding="async"
                :fetchpriority="idx === 0 ? 'high' : idx < 8 ? 'auto' : 'low'"
                @load="onTileImageLoad(item.id)"
                @error="onTileImageLoad(item.id)"
              >
              <span v-else class="solution-icon" aria-hidden="true">{{ item.icon || '📘' }}</span>
            </div>
            <h3 class="solution-title">{{ item.title }}</h3>
            <p class="solution-desc">{{ item.subtitle || item.summary || item.intro || '' }}</p>
          </router-link>
        </article>
      </div>
      <p class="section-cta">
        <router-link to="/solutions" class="link-more">进入解决方案中心 →</router-link>
      </p>
    </div>
  </section>
</template>

<script>
import { fetchSolutions } from '../api/solutions'

export default {
  name: 'SolutionsSection',
  props: {
    prefetchItems: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      items: [],
      imageReady: {}
    }
  },
  async mounted() {
    if (Array.isArray(this.prefetchItems) && this.prefetchItems.length) {
      this.items = this.prefetchItems.map((item) => ({ ...item }))
      return
    }
    this.imageReady = {}
    try {
      const list = await fetchSolutions()
      this.items = Array.isArray(list) ? list : []
    } catch (e) {
      console.warn('[Solutions] 接口不可用，使用内置兜底数据', e)
    }
  },
  methods: {
    onTileImageLoad(id) {
      if (id == null) return
      this.imageReady = { ...this.imageReady, [id]: true }
    }
  }
}
</script>

<style scoped>
.solutions {
  padding: 100px 0;
  background: #f0f4f8;
}

.section-head {
  text-align: center;
  margin-bottom: 48px;
}

.section-title {
  font-size: 42px;
  margin-bottom: 16px;
  color: #0c4a6e;
  font-weight: 700;
}

.section-lead {
  font-size: 18px;
  color: #475569;
  max-width: 720px;
  margin: 0 auto;
  line-height: 1.75;
}

.solutions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 24px;
  max-width: 1200px;
  margin: 0 auto;
}

.solution-card {
  background: #fff;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  transition: box-shadow 0.25s, border-color 0.25s, transform 0.25s;
}

.solution-card:hover {
  box-shadow: 0 12px 40px rgba(12, 74, 110, 0.12);
  border-color: #0ea5e9;
  transform: translateY(-4px);
}

.solution-media {
  width: 280px;
  height: 192px;
  margin-bottom: 16px;
  border-radius: 10px;
  background: #f1f5f9;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.solution-media::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(110deg, transparent 0%, rgba(255, 255, 255, 0.55) 45%, transparent 90%);
  background-size: 220% 100%;
  animation: solution-media-shimmer 1.35s ease-in-out infinite;
  pointer-events: none;
  z-index: 0;
}

.solution-media--ready::after {
  display: none;
}

.solution-cover {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  opacity: 0;
  transition: opacity 0.35s ease;
}

.solution-media--ready .solution-cover {
  opacity: 1;
}

@keyframes solution-media-shimmer {
  0% { background-position: 100% 0; }
  100% { background-position: -100% 0; }
}

.solution-icon {
  font-size: 40px;
  line-height: 1;
}

.solution-link {
  display: block;
  color: inherit;
  padding: 28px 24px;
}

.solution-title {
  font-size: 19px;
  color: #0c4a6e;
  font-weight: 600;
  margin-bottom: 10px;
}

.solution-desc {
  font-size: 14px;
  color: #64748b;
  line-height: 1.65;
  margin: 0;
}

.section-cta {
  text-align: center;
  margin-top: 40px;
}

.link-more {
  color: #0284c7;
  font-weight: 600;
  font-size: 16px;
}

.link-more:hover {
  color: #0369a1;
}

@media (max-width: 768px) {
  .section-title {
    font-size: 32px;
  }
}
</style>
